<template>
  <component
    :is="fieldInstance.field.component"
    v-bind="componentProps"
    class="currency-field"
    @focus="$emit('focus')"
    @blur="$emit('blur')"
    @[fieldInstance.field.emit]="emit" />
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'CurrencyField',

  components: {
    SwitcherTabs: () => import('Components/ui/Tabs/SwitcherTabs.vue'),
    SearchInput: () => import('Components/ui/Input/SearchInput.vue'),
    UiKitSelect: () => import('Components/ui/Select/UiKitSelect.vue'),
    UiInput: () => import('Components/ui/Input/UiInput.vue'),
  },

  props: {
    fieldInstance: {
      type: Object,
      required: true,
    },

    isDisabled: {
      type: Boolean,
      default: false,
    },

    hasError: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState(['userDevice']),

    componentProps() {
      const props = {
        ...this.fieldInstance.field.props,
        [this.fieldInstance.field.valueKey]: this.fieldInstance.field.value,
        disabled: this.isDisabled || this.fieldInstance.field.props.disabled,
        error: this.errorText,
        'text-appendix': this.appendix,
        ...(this.fieldInstance.field.component === 'search-input' ? { 'always-show-results': true } : {}),
      };

      // для аккаунтов нужен label, для голды не нужен
      if (this.fieldInstance.field.component === 'ui-kit-select') {
        delete props.label;
      }

      return props;
    },

    appendix() {
      if (this.userDevice.innerWidth > 1279) {
        return {
          prefix: this.fieldInstance.fieldData?.textAppendix?.prefix,
        } ?? {};
      }

      if (typeof this.fieldInstance.fieldData?.textAppendix?.mobilePrefix !== 'undefined') {
        return {
          prefix: this.fieldInstance.fieldData.textAppendix.mobilePrefix,
        };
      }

      return {
        prefix: `${this.fieldInstance.fieldData.title} |`,
      };
    },

    errorText() {
      if (!this.hasError) {
        return false;
      }

      return this.fieldInstance.fieldData?.errorText ?? 'This field is required';
    },
  },

  methods: {
    emit(event) {
      if (this.fieldInstance.field.props.type === 'number') {
        event = Number(event);
      }

      this.fieldInstance.setValue(event);
      this.$emit('input', {
        field: this.fieldInstance,
        value: event,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .currency-field {
    --font-size: var(--field-font-size, 15px);
    --height: var(--field-height, 48px);
  }
</style>
